import oceanBeachTheme from 'typography-theme-ocean-beach'

import { TypographyOptions } from './types.js'

export const typography: TypographyOptions = {
  /**
   * @tag Vite migration
   * 'typography-theme-ocean-beach' module provides a default export and breaks Rollup ESM-CJS interop
   * https://github.com/vitejs/vite/issues/2139#issuecomment-1024852072
   */
  ...(oceanBeachTheme.default ? oceanBeachTheme.default : oceanBeachTheme),
  baseFontSize: '16px',
}
